import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SlotDataService } from '../slots-data.service';
import * as moment from 'moment-timezone';
import { SlotsService } from '../slots.service';


@Component({
  selector: 'app-slot-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class SlotHeaderComponent implements OnInit {
  
  public language: string;
  public TimeZoneList = [];
  public timezoneid;
  public currentLang = 'nl-NL';
  public logoUrl: string;
  constructor(private translate: TranslateService,
    private slotsDataService: SlotDataService,
    private slotsService:SlotsService
  ) {}
  languages = [{
    name: 'English',
    value: 'en-US'
  }, {
    name: 'Nederlands',
    value: 'nl-NL'
  }]

  ngOnInit() {
    this.logoUrl = this.slotsDataService.getLogoUrl();
    this.language = localStorage.getItem('language-slots');
    // this.onlangChange(this.language == '')
    if(this.language == 'en-US' || this.language == 'nl-NL'){
      this.onlangChange(this.language);
      this.currentLang = this.language
    }else{
      this.onlangChange('nl-NL')
      this.currentLang = 'nl-NL'
    }
    // this.onlangChange('nl-NL')
    // this.translate.use('nl-NL')
    moment.tz.names().forEach((timezone,i)=> {
      this.TimeZoneList.push({
        label:timezone,
        value:i.toString()
      })
    });
     
    
    var localTimezone = this.slotsDataService.timezone ? 
                        this.slotsDataService.timezone : 
                        'Europe/Amsterdam';
    this.slotsDataService.timezone = localTimezone;
    
    this.TimeZoneList.forEach(timezone=>{
      if(timezone.label == localTimezone){
        this.timezoneid = timezone.value.toString()
        return;
      }
    })
  }
  

  /**
   * Function called when language changes
   */
  onlangChange(ln) {
    this.translate.use(ln);
    localStorage.setItem('language-slots', ln);
    this.slotsService.setLanguage(ln)
  }

  /**
   * Function to set timezone
   * @param e 
   */
  setTimezone(e){
    var date = new Date();
    var m  = moment(date).tz(e.label)
    this.slotsDataService.timezoneOffset = m._offset * 60 * 1000 * -1;
    this.slotsDataService.timezone = e.label;
    this.slotsService.timezoneChange(true);

  }

}



// WEBPACK FOOTER //
// ./src/app/slots/header/header.component.ts